export const Networks = {
    MAINNET: "mainnet",
    TESTNET: "testnet",
}
